const isUnknownLink = (error) => error?.response?.status === 404;

// Re-sending a document issues a new link and the server drops the old one, so a 404 here
// almost always means the client opened an earlier email.
export const signingLinkErrorMessage = (error) =>
  isUnknownLink(error)
    ? "This link is no longer valid. A newer link may have been sent to you, so please open the most recent email about this document. If you can't find it, ask your admin to send it again."
    : "We couldn't load this document. Please check your connection and try again.";
